import {initialStateInterface} from '@/store/states/storage'

export const LOCAL_STORAGE_KEY = 'MOG_STORAGE_KEY'

class LocalStorageResolver {
  get getJwt(): string {
    const storage = this.getStorage()
    return storage ? storage.jwt : ''
  }

  get langauge(): string {
    const storage = this.getStorage()
    return storage ? storage.language : 'en'
  }

  setStorage(state: initialStateInterface) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state))
  }

  getStorage() {
    const storage = localStorage.getItem(LOCAL_STORAGE_KEY)
    return storage !== null ? JSON.parse(storage) : null
  }
}

export default new LocalStorageResolver()
